export default __webpack_public_path__ + "static/media/footer-art.9df64f08.svg";